import {
    getActiveLicenses,
    getClassLastHomeworkLessonInfo,
    getClassLastLesson,
    getClassLastLessonId,
    getClassLesson, getClassLessonHomework
} from "../../../network/Endpoint";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import { mainClassState } from "../../../recoil/classes/classesState";
import {useEffect, useRef, useState} from "react";
import StageBadge from "../components/classLesson/StageBadge";
import {
    gradeState,
    semesterState,
    lessonState, lessonHomeworkState,
} from "../../../recoil/lesson/lessonState";
import CurriculumDropdown from "../components/classLesson/CurriculumDropdown";
import {topMenuTypeState} from "../../../recoil/menuState/topMenuState";
import Filter from "../../../assets/images/fillter.png"
import {cloneDeep} from "lodash";
import {teacherGradeState, teacherIdState, teacherSemesterState} from "../../../recoil/teacher/teacherIdState";
import {useNavigate} from "react-router-dom";
import PurchaseInfoModal from "../../../components/PurchaseInfoModal";
import PurchaseHomeworkImage from "../../../assets/images/purchaseHomework.png"
import StageBadgeHomework from "../components/classLesson/StageBadgeHomework";
import SideMenu from "../../../components/SideMenu";
import {curriculumState} from "../../../recoil/curriculums/curriculumState";

const ClassHomeworkPage = () => {
    const curriculumData = useRecoilValue(curriculumState);
    const teacherId = useRecoilValue(teacherIdState);
    const mainClass = useRecoilValue(mainClassState);
    const [lessonHomeworkResults, setLessonHomeworkResults] = useState([]);
    const [grade, setGrade] = useRecoilState(gradeState);
    const [semester, setSemester] = useRecoilState(semesterState);
    const teacherGrade = useRecoilValue(teacherGradeState);
    const teacherSemester = useRecoilValue(teacherSemesterState);
    const [lessonInfoId, setLessonInfoId] = useRecoilState(lessonHomeworkState);
    const [activeCount, setActiveCount] = useState(0);

    const [completedCount, setCompletedCount] = useState(0);
    const [dueSoonCount, setDueSoonCount] = useState(0);
    const [inProgressCount, setInProgressCount] = useState(0);
    const [notStartedCount, setNotStartedCount] = useState(0);

    const [isFirstLoad, setIsFirstLoad] = useState(true); // ✅ 최초 로딩 여부 추가

    const setMenuType = useSetRecoilState(topMenuTypeState);

    const [showTabType, setShowTabType] = useState(0);

    const [activeLicenses, setActiveLicenses] = useState(null);
    const [showPurchaseInfoModal, setShowPurchaseInfoModal] = useState(false)
    const [onAssignHomework, setOnAssignHomework] = useState(false);
    const [homeworkStageIds, setHomeworkStageIds] = useState([]);

    const navigate = useNavigate();

    /** ✅ 마지막 숙제 데이터를 서버에서 가져와 설정 */
    const fetchLastClassHomework = async () => {
        if (!mainClass || !mainClass.classId) return;

        try {
            const body = {
                classId: mainClass.classId
            };
            const res = await getClassLastHomeworkLessonInfo(body);
            const statusCode = res.data.status.code;

            if (statusCode === "Success") {
                const data = res.data.data;
                let lessonInfoId = 255329;
                if(grade&&semester){
                    lessonInfoId = curriculumData.lessonSemesterList[(teacherGrade-1)*2+teacherSemester -1].lessonChapters[0].lessons[0].lessonInfoId;
                }
                setIsFirstLoad(false);
                setLessonInfoId(!data.lessonInfoId || data.lessonInfoId === 0 ? lessonInfoId : data.lessonInfoId);
            } else{
                alert(`ERROR: 학생 정보 로드 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    /** ✅ lessonInfoId가 변경될 때 서버에서 새 데이터 가져오기 (최초 실행 제외) */
    const fetchGetClassHomework = async () => {
        if (!lessonInfoId || isFirstLoad) return;

        try {
            const body = { classId: mainClass.classId, lessonInfoId };
            const res = await getClassLessonHomework(body);
            const statusCode = res.data.status.code;

            if (statusCode === "Success") {
                const data = res.data.data;
                setLessonHomeworkResults(data.lessonHomeworkResults);
                setCompletedCount(data.completedCount);
                setDueSoonCount(data.dueSoonCount);
                setInProgressCount(data.inProgressCount);
                setNotStartedCount(data.notStartedCount);
                setGrade(data.lessonHomeworkResults[0].lessonInfo.grade);
                setSemester(data.lessonHomeworkResults[0].lessonInfo.semester);
                setLessonInfoId(data.lessonHomeworkResults[0].lessonInfo.lessonInfoId);
                setActiveCount(data.activeCount?data.activeCount : 0);
            } else {
                alert(`ERROR: 학생 정보 로드 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    /**
     * 적용 가능한 라이센스 가져오기
     * @returns {Promise<void>}
     */
    const fetchActiveLicenses = async () => {
        try {
            const body = {
                teacherId: teacherId
            }
            const res = await getActiveLicenses(body);

            const statusCode = res.data.status.code;
            if(statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseList)
                setActiveLicenses(licenses);
                if(licenses.length>0){
                    if(lessonInfoId){
                        fetchGetClassHomework();
                        setIsFirstLoad(false);
                    }else{
                        setIsFirstLoad(false);
                        fetchLastClassHomework();
                    }
                }else{
                    openPurchaseInfoModal();
                }
            }else {
                alert(`ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        }catch (error) {
            alert(`[${error.message}]\n이용권 불러오는 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    }

    const openPurchaseInfoModal = () => {
        setShowPurchaseInfoModal(true)
    }


    /** ✅ mainClass가 변경될 때 최초 1회 실행 */
    useEffect(() => {
        if (mainClass && mainClass.classId) {
            fetchActiveLicenses();
        }
    }, [mainClass?.classId]); // mainClass 전체가 아닌 classId만 의존성으로 추가


    /** ✅ lessonInfoId 변경될 때마다 새로운 데이터 가져오기 (최초 실행 제외) */
    useEffect(() => {
        if(!isFirstLoad){
            fetchGetClassHomework();
        }
    }, [lessonInfoId, isFirstLoad]);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("classLesson");
        }
    },[setMenuType])

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            {/* 드롭다운 메뉴 */}
            <div className="flex flex-row justify-center items-center max-w-[1189px] w-full mt-12 mb-10 gap-3">
                <div className="relative w-[1189px] h-[44px] ">
                    <CurriculumDropdown
                        grade={grade}
                        setGrade={setGrade}
                        semester={semester}
                        setSemester={setSemester}
                        lessonInfoId={lessonInfoId}
                        setLessonInfoId={setLessonInfoId}
                        isFirstLoad={isFirstLoad}
                        setShowTabType={setShowTabType}
                        homeworkStageIds={homeworkStageIds}
                        setHomeworkStageIds = {setHomeworkStageIds}
                        onAssignHomework={onAssignHomework}
                        setOnAssignHomework={setOnAssignHomework}
                        fetchGetClassHomework={fetchGetClassHomework}
                        pageType="homework"
                    />
                </div>
            </div>

            <div
                className="flex flex-row items-center justify-center gap-3  text-center text-[16px] mt-3"
            >
                <img
                    src={Filter}
                    alt="filter icon"/>
                <div
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 0
                        ? 'bg-white text-[#355BDF] border-[#7494FF]'
                        : 'bg-[#D7E5FE] text-[#50555F] border-[#D7E5FE]'
                    }`}
                    onClick={() => setShowTabType(0)}
                >
                    <div
                        className=" font-[700]"
                    >전체 보기
                    </div>
                    <div className="text-[#174CD4] font-[900]">
                        {lessonHomeworkResults && lessonHomeworkResults.length}
                    </div>
                </div>
                <div
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 1
                        ? 'bg-white text-[#757d8d] border-[#DDD]'
                        : 'bg-[#DFDFDF] text-[#50555F] border-[#DFDFDF]'
                    }`}
                    onClick={() => setShowTabType(1)}
                >
                    <div
                        className="font-[700]"
                    >
                        미발송한 숙제
                    </div>
                    <div className="text-[#8E8E8E] font-[900]">
                        {notStartedCount && notStartedCount}
                    </div>
                </div>
                <div
                    onClick={() => setShowTabType(2)}
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 2
                        ? 'bg-white text-[#008351] border-[#00C472]'
                        : 'bg-[#D1F4DE] text-[#50555F] border-[#D1F4DE]'
                    }`}
                >
                    <div
                        className="font-[700]"
                    >
                        종료된 숙제
                    </div>
                    <div className="text-[#009D38] font-[900]">
                        {completedCount && completedCount}
                    </div>
                </div>
                <div
                    onClick={() => setShowTabType(3)}
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 3
                        ? 'bg-white text-[#DE4E00] border-[#FF8C00]'
                        : 'bg-[#FFF6E2] text-[#50555F] border-[#FFF6E2]'
                    }`}
                >
                    <div
                        className="font-[700]"
                    >
                       진행중 숙제
                    </div>
                    <div className="text-[#FF8C00] font-[900]">
                        {inProgressCount && inProgressCount}
                    </div>
                </div>
                <div
                    onClick={() => setShowTabType(4)}
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 4
                        ? 'bg-white text-[#ED1914] border-[#FC5955]'
                        : 'bg-[#FED7D8] text-[#50555F] border-[#FED7D8]'
                    }`}
                >
                    <div
                        className="font-[700]"
                    >
                       마감 임박 숙제
                    </div>
                    <div className="text-[#FC5955] font-[900]">
                        {dueSoonCount && dueSoonCount}
                    </div>
                </div>
            </div>

            {/* 스테이지 정보 부분 */}
            <div className="flex max-w-[1044px] w-full mt-3 mb-40">
                <div className="flex flex-row justify-between flex-wrap w-full">
                    {(() => {
                        const filteredResults = lessonHomeworkResults && lessonHomeworkResults.length > 0
                            ? lessonHomeworkResults.filter(result => {
                                if (showTabType === 1) return result.activeDate === null;
                                if (showTabType === 2) return result.activeDate !== null && result.leftHomeworkDate <= 0;
                                if (showTabType === 3) return result.activeDate !== null && result.leftHomeworkDate > 0;
                                if (showTabType === 4) return result.activeDate !== null && result.leftHomeworkDate > 0 && result.leftHomeworkDate <= 3;
                                return true; // showTabType === 0일 때 전체 표시
                            })
                            : [];

                        return filteredResults.length > 0 ? (
                            filteredResults.map((result, index) => (
                                <StageBadgeHomework
                                    key={index}
                                    index={index}
                                    grade={grade && grade}
                                    semester={semester && semester}
                                    stageSummary={result}
                                    classInfo={mainClass}
                                    onAssignHomework={onAssignHomework}
                                    homeworkStageIds={homeworkStageIds}
                                    setHomeworkStageIds = {setHomeworkStageIds}
                                    fetchGetClassHomework = {fetchGetClassHomework}
                                    notStartedComment="아직 숙제를 발송하지 않았어요."
                                />
                            ))
                        ) :
                            ( <div
                                className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                <div
                                    className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                    {activeLicenses === null 
                                        ? '숙제 기능은 유료 기능으로 결제 후 사용가능 합니다.'
                                        : showTabType === 1 
                                            ? '미발송한 숙제가 없습니다.'
                                            : showTabType === 2
                                                ? '아직 종료된 숙제가 없습니다.'
                                                : showTabType === 3
                                                    ? '아직 진행중인 숙제가 없습니다.'
                                                    : showTabType === 4
                                                        ? '아직 마감 임박 숙제가 없습니다.'
                                                        : '숙제가 없습니다.'
                                    }
                                </div>
                            </div>
                            );
                    })()}
                </div>
            </div>

            <PurchaseInfoModal
                showPurchaseInfoModal={showPurchaseInfoModal}
                setShowPurchaseInfoModal={setShowPurchaseInfoModal}
                purchaseInfoImage={PurchaseHomeworkImage}
            />
            <SideMenu></SideMenu>
        </div>
    );
};

export default ClassHomeworkPage;
